import {
    HttpClient,
    envelopeField,
    getApiBaseUrl,
    type MaeizEnvelope,
    type User,
} from "@maeiz/core";
import { useAuthStore } from "@stores/auth";

export const httpClient = new HttpClient(getApiBaseUrl());

httpClient.setRequestInterceptor((config) => {
    const token = useAuthStore.getState().token;
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

httpClient.setUnauthorizedHandler(async () => {
    if (!useAuthStore.getState().token) {
        useAuthStore.getState().clearAuth();
        return null;
    }
    try {
        const res = (await httpClient.post<unknown>(
            "/auth/refresh-token"
        )) as unknown as MaeizEnvelope;
        const token = envelopeField<string>(res, "accessToken", "");
        if (token) {
            const nextUser = envelopeField<User>(res, "user") ?? useAuthStore.getState().user;
            if (nextUser) {
                useAuthStore.getState().setAuth(nextUser, token);
            }
            return token;
        }
    } catch {
        /* refresh failed — fall through and clear the session */
    }
    useAuthStore.getState().clearAuth();
    return null;
});
